import { createAction } from "redux-actions";
import { RootState } from "../reducers";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { url, post } from "../../assets/javascripts/http";
import { isTrial } from "../../utils/url";
import { message, Modal } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PostureService, ExaminationService, PersonaService, OrganizationService, MembershipService } from "../adapters";
import {
  ExamineeResult,
  GetExamineeByIdResponse,
  ExaminerResult,
  ExaminationReportResult,
} from "../../api/base/examination/examination";
import moment from "moment";
const COS = require("cos-js-sdk-v5");
import { actionLogoutSuccess } from "./user";
import intl, { getLanguageCode, getCurrentMessages } from "../../assets/javascripts/intl";

let personaService = new PersonaService(url, post);
let postureService = new PostureService(url, post);
let examinationService = new ExaminationService(url, post);
let membershipService = new MembershipService(url, post);

export function getExaminerResult() {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      let getMyAllExaminers = await examinationService.getMyAllExaminers({});
      let examinerResults = getMyAllExaminers.examinerResults || [];
      dispatch(getExaminerResultSuccess({ examinerResult: examinerResults }));
    } catch (error: any) {}
  };
}
export interface getExaminerResultSuccessPayload {
  //ExaminerResult
  examinerResult: Array<ExaminerResult>;
}
export const GET_EXAMINER_RESULT = "GET_EXAMINER_RESULT";
export const getExaminerResultSuccess = createAction(
  GET_EXAMINER_RESULT,
  (payload: getExaminerResultSuccessPayload) => {
    return payload;
  }
);
export interface SaveExaminerResultAndUpdateExamination {
  examinerResult: ExaminerResult;
  doctorAdvice: string;
}
export function saveExaminerResultAndUpdateExamination(args: SaveExaminerResultAndUpdateExamination) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    console.log({ args });
    let reportPageData = getState().institution.reportPageData;
    console.log(reportPageData)
    let examinationReportResult = reportPageData.examinationReportResult;
    try {
      // let createExaminer = await examinationService.createExaminer({
      //     examinerInfo: {
      //         name: args.examinerResult.name,
      //         // phone: "",
      //         // organizationId: 0,
      //         // id: 0
      //     }
      // })
      let updateExaminationReport = await examinationService.updateExaminationReport({
        examinationReportInfo: {
          id: examinationReportResult.examinationReportId,
          examineeReportDetailType: 1,
          doctorAdvice: args.doctorAdvice,
          // examinerId: createExaminer.examinerId,
          evaluator_account_id:reportPageData.examinationReportResult.examinerAccountId,
          evaluate_time:{
            seconds: moment().unix(),
            nanos: (moment().unix() % 1000) * 1000000
          }
        },
      });
      toast.success(intl.formatMessage({ id: "succeedToSave" }));

      console.log(message);
      // let examinationReportId = localStorage.getItem('examinationReportId') || ''
      // dispatch(getReportPageDataByUuidAndExamineeId({
      //     examinationReportId: +examinationReportId
      // }))
    } catch (error: any) {
      message.error({
        content: intl.formatMessage({ id: "failedToSave" }),
        duration: 1,
      });
    }
  };
}
export interface SaveExaminerResultSuccessPayload {
  //ExaminerResult
  examinerResult: Array<ExaminerResult>;
}
export const SAVE_EXAMINER_RESULT = "SAVE_EXAMINER_RESULT";
export const saveExaminerResultSuccess = createAction(
  SAVE_EXAMINER_RESULT,
  (payload: SaveExaminerResultSuccessPayload) => {
    return payload;
  }
);

export function updatePosturePoints(args: any) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    let institution = getState().institution;
    let reportPageData = JSON.parse(JSON.stringify(institution.reportPageData));
    try {
      let front = args.body.front.points;
      let side = args.body.side.points;
      let back = args.body.back.points;
      console.log({ args, front, side });

      let res = await postureService.updatePostureReportCoordinate({
        front: front,
        side: side,
        uuid: args.uuid,
        back: back,
      });
      message.success({
        content: intl.formatMessage({ id: "succeedToSave" }),
        duration: 5,
      });

      let postureData = await postureService.getPostureReport({
        uuid: args.uuid, //"c9df70e2-4d05-409c-9822-7c11a1dd2736",
        language: "zh",
      }, isTrial() ? reportPageData.examinationReportResult.examinerAccountId : undefined);
      reportPageData.update = true;
      reportPageData.postureData = postureData;

      dispatch(saveReportPageData({ reportPageData: reportPageData }));
    } catch (error: any) {
      reportPageData.update = false;
      dispatch(saveReportPageData({ reportPageData: reportPageData }));
      message.error({
        content: intl.formatMessage({ id: "failedToSave" }),
        duration: 5,
      });
    }
  };
}
let organizationService = new OrganizationService(url, post);

export class ReportData {
  postureData: any; //ExaminationReportResult
  examinationReportResult: ExaminationReportResult;
  institutionLogo: string = "";
  doctorMsg: string = "";
  doctorName: string = "";
  institutionName: string = "";
  reportGenDate: string | number = "";
  user: ExamineeResult; //ExamineeResult
  examinationReportId: number;
  update: boolean = false;
  muscleStateResults: any[] = [];

  constructor() {
    this.postureData = Object.assign({});
    this.examinationReportResult = Object.assign({});
    this.user = Object.assign({});
    this.examinationReportId = 0;
  }
}

export interface GetReportPageDataByUuidAndExamineeIdArgs {
  examinationReportId: number;
  language?: string;
}

export function getReportPageDataByUuidAndExamineeId(args: GetReportPageDataByUuidAndExamineeIdArgs) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    message.loading(getCurrentMessages().loading);
    let institution = getState().institution.institution;
    let lang = args.language || "zh";

    let pageData: ReportData = Object.assign({ doctorName: "" });
    let postureData: any = Object.assign({});

    pageData.institutionLogo = institution.logo;
    pageData.institutionName = institution.name;

    try {
      let examinationReport = await examinationService.getExaminationReportById({
        examinationReportId: args.examinationReportId,
      });
      postureData = await postureService.getPostureReport({
        // uuid:"61d7906c-300b-4aa7-a272-6f9c326cdcbb",//"c9df70e2-4d05-409c-9822-7c11a1dd2736",
        uuid: examinationReport.examinationReportResult.examineeReportDetailId || "", //"c9df70e2-4d05-409c-9822-7c11a1dd2736",
        language: lang,
      }, isTrial() ? examinationReport.examinationReportResult.examinerAccountId : undefined);

      // 获取肌肉状态
      if (postureData.resultPosture === "OK") {
        let muscleStateQuery: any[] = [];
        let body = postureData.body;
        let risks = [...body.front.risks, ...body.side.risks];
        let hightRisks = risks.filter((r) => {
          // return r.level === 'severe'
          return true;
          // return r.level !== 'normal'
        });
        // 转换字符串level到枚举值
        const levelMap: any = {
          'normal': 1,
          'mild': 2,
          'severe': 3
        };
        hightRisks.map((r) => {
          muscleStateQuery.push({
            level: levelMap[r.level] || 0,
            // direction: Side[r.direction] || 0,
            direction: 0,
            key: r.key,
          });
        });
        let res_muscle = await postureService.getMuscleState({
          muscleStateQuery,
          lang: getLanguageCode(),
        });
        pageData.muscleStateResults = res_muscle.muscleStateResults;
      }
      pageData.postureData = postureData;
      let res: any = examinationReport.examinationReportResult.examineeResult || {};
      pageData.user = res || {};
      pageData.examinationReportResult = examinationReport.examinationReportResult;
      let t = examinationReport.examinationReportResult["creationTimestamp"] || "";
      t = moment(+t).format("YYYY-MM-DD HH:m:s");
      pageData.reportGenDate = t;
      pageData.doctorMsg = examinationReport.examinationReportResult["doctorAdvice"] || "";
      pageData.doctorName = examinationReport.examinationReportResult.examinerResult.name || "";

      localStorage.setItem("examinationReportId", args.examinationReportId + "");

      dispatch(saveReportPageData({ reportPageData: pageData }));
    } catch (error: any) {
      dispatch(saveReportPageData({ reportPageData: pageData }));
    }

    try {
    } catch (error: any) {
      console.log(error);
    }
    message.destroy();
  };
}

export interface GetReportByUuidArgs {
  uuid: string;
  language?: string;
}

export function checkReportExistsByUuid(args: GetReportByUuidArgs) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    let lang = args.language || "en";
    let postureData: any = Object.assign({});
    let pageData: ReportData = Object.assign({ doctorName: "" });
    try {
      let examinationReport = await examinationService.getExaminationReportByExamineeReportDetailId({
        examineeReportDetailId: args.uuid,
      });
      postureData = await postureService.getPostureReport({
        uuid: examinationReport.examinationReportResult.examineeReportDetailId || "",
        language: lang,
      }, isTrial() ? examinationReport.examinationReportResult.examinerAccountId : undefined);
      pageData.postureData = postureData
      dispatch(saveReportPageData({ reportPageData: pageData }));
    } catch (error: any) {
    }
  }
}

export function getReportByUuid(args: GetReportByUuidArgs) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    message.loading(getCurrentMessages().loading);
    let institution = getState().institution.institution;
    let lang = args.language || "en";

    let pageData: ReportData = Object.assign({ doctorName: "" });
    let postureData: any = Object.assign({});

    pageData.institutionLogo = institution.logo;
    pageData.institutionName = institution.name;

    try {
      let examinationReport = await examinationService.getExaminationReportByExamineeReportDetailId({
        examineeReportDetailId: args.uuid,
      });
      postureData = await postureService.getPostureReport({
        uuid: examinationReport.examinationReportResult.examineeReportDetailId || "",
        language: lang,
      }, isTrial() ? examinationReport.examinationReportResult.examinerAccountId : undefined);

      // 获取肌肉状态
      if (postureData.resultPosture === "OK") {
        let muscleStateQuery: any[] = [];
        let body = postureData.body;
        let risks = [...body.front.risks, ...body.side.risks];
        let hightRisks = risks.filter((r) => {
          return true;
        });
        // 转换字符串level到枚举值
        const levelMap: any = {
          'normal': 1,
          'mild': 2,
          'severe': 3
        };
        hightRisks.map((r) => {
          muscleStateQuery.push({
            level: levelMap[r.level] || 0,
            direction: 0,
            key: r.key,
          });
        });
        let res_muscle = await postureService.getMuscleState({
          muscleStateQuery,
          lang: lang,
        });
        pageData.muscleStateResults = res_muscle.muscleStateResults;
      }
      pageData.postureData = postureData;
      let res: any = examinationReport.examinationReportResult.examineeResult || {};
      pageData.user = res || {};
      pageData.examinationReportResult = examinationReport.examinationReportResult;
      let t = examinationReport.examinationReportResult["creationTimestamp"] || "";
      t = moment(+t).format("YYYY-MM-DD HH:m:s");
      pageData.reportGenDate = t;
      pageData.doctorMsg = examinationReport.examinationReportResult["doctorAdvice"] || "";
      pageData.doctorName = examinationReport.examinationReportResult.examinerResult.name || "";

      localStorage.setItem("examinationReportId", examinationReport.examinationReportResult.examinationReportId + "");

      dispatch(saveReportPageData({ reportPageData: pageData }));
    } catch (error: any) {
      dispatch(saveReportPageData({ reportPageData: pageData }));
    }

    message.destroy();
  };
}

//getReportPageDataByUuidAndExamineeId
export const SAVE_REPORT_PAGE_DATA = "SAVE_REPORT_PAGE_DATA";

export interface SaveReportPageDataPayload {
  reportPageData: ReportData;
}
export const saveReportPageData = createAction(SAVE_REPORT_PAGE_DATA, (payload: SaveReportPageDataPayload) => {
  return payload;
});

export function actionGetInstitution() {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      let organizationId = +(localStorage.getItem("organizationId") || "");

      let res_all = await Promise.all([
        await personaService.getSocial({}),
        await personaService.getContact({}),
        await membershipService.getMembershipByAccessToken({}),
      ]);
      let socialResult = res_all[0].socialResult || {};
      let contactInfoResult = res_all[1].contactInfoResult || {};
      let membershipArr = res_all[2].membership || [];

      let member;
      if (membershipArr.length > 1) {
        member = membershipArr.reduce((p: any, v: any) => (p.expiredTimestamp < v.expiredTimestamp ? v : p));
      } else {
        member = membershipArr[0] || {};
      }

      let status = member.name.split("-")[1];
      let t = Date.parse(new Date() + "");
      let loginStatus = getState().user.loginStatus;
      if (status === "7天体验") {
        if (t > parseInt(member.expiredTimestamp)) {
          //7天过期
          status = "待激活";
          if (loginStatus) {
            dispatch(
              actionLogoutSuccess({
                loginStatus: false,
              })
            );
            Modal.error({
              className: "modal_access",
              title: "该账号试用已结束",
              content: "请联系创感科技工作人员激活账号",
            });
          }
        } else {
          status = "试用";
        }
      } else {
        if (member.accessAuthorized !== "ALL") {
          // 其他版本 无后台登录权限
          if (loginStatus) {
            dispatch(
              actionLogoutSuccess({
                loginStatus: false,
              })
            );
            Modal.error({
              className: "modal_access",
              title: "该账号没有登录后台权限",
              content: "请联系创感科技工作人员开启权限",
            });
          }
        }
      }

      let data = {
        name: "",
        logo: "",
        accountId: socialResult.accountId,
        realName: socialResult.realName,
        phoneNumber: contactInfoResult.mobileNumber,
        status: status,
        surplusCount: 0,
        accessAuthorized: member.accessAuthorized,
        expiredTimestamp: member.expiredTimestamp,
      };

      if (organizationId) {
        let data_org = {
          ids: [organizationId],
        };
        let res_org = await organizationService.getOrganizationByIds(data_org);
        let org = res_org.organizations[0] || {};
        data.name = org.name;
        data.logo = org.organizationLogo || "";
      }

      // 检测次数
      let res_report = await postureService.getLicenseInfoByAccountIds({
        accountIds: [data.accountId],
      });
      let detection =
        res_report.licenseInfoResults.filter((d) => {
          return d.accountId === data.accountId;
        })[0] || {};
      data.surplusCount = detection.count || 0;

      dispatch(
        actionGetInstitutionSuccess({
          data: data,
        })
      );
    } catch (error: any) {
      message.destroy();
      let response = error.response;
      if (response && response.status === 500) {
        let headers = error.response.headers;
        let str = headers["senno-exception-message"];
        if (str.toLowerCase().search("account id not found") != -1) {
          dispatch(
            actionLogoutSuccess({
              loginStatus: false,
              invaildLogin: true,
            })
          );
          console.log("重新登录...");
        } else {
          message.error("系统错误", 5);
          console.log("系统错误");
        }
      }
    }
  };
}

export function actionGetInstitutionByOrgId(organizationId) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      let data_org = {
        ids: [organizationId],
      };
      let res_org = await organizationService.getOrganizationByIds(data_org);
      let org = res_org.organizations[0] || {};

      let data = {
        name: org.name,
        logo: org.organizationLogo || "",
      };

      dispatch(
        actionGetInstitutionSuccess({
          data: data,
        })
      );
    } catch (error: any) {}
  };
}

export const ACTION_GETINSTITUTION_SUCCESS = "USER.ACTION_GETINSTITUTION_SUCCESS";

export interface ActionGetInstitutionSuccessPayload {
  data: any;
}

export const actionGetInstitutionSuccess = createAction(
  ACTION_GETINSTITUTION_SUCCESS,
  (payload: ActionGetInstitutionSuccessPayload) => {
    return payload;
  }
);

// 当账号无组织时需要创建

async function createOrganization(data) {
  let data_type = {
    type: "posture.expert",
  };
  let res_type = await organizationService.getOrganizationsByType(data_type);
  let organizationId_type = res_type.organizations[0].id || -1;
  if (organizationId_type == -1) return;
  let data_group = {
    organizationId: organizationId_type,
  };
  let res_group = await organizationService.getOrganizationGroupsByOrganizationId(data_group);
  let organizationGroupId = res_group.organizationGroups[0].id;

  let data_org = {
    createOrganization: {
      organizationGroupId: organizationGroupId,
      name: data.name,
      description: data.realName + " " + data.phone,
      type: "posture.expert.platform",
    },
  };
  let res = await organizationService.createOrganization(data_org);
  let organizationId = res.organizationId;
  let data_accountGroup = {
    createAccountGroup: {
      name: data.name,
      displayName: data.name,
      description: data.contactPerson + " " + data.phone,
      organizationId: organizationId,
      account_count: 0,
    },
  };
  let res_accountGroup = await organizationService.createAccountGroup(data_accountGroup);
  let accountGroupId = res_accountGroup.accountGroupId;
  let data_addAccount = {
    accountGroupId: accountGroupId,
    accountId: data.accountId,
  };
  await organizationService.addAccountToAccountGroupByAccountId(data_addAccount);

  localStorage.setItem("organizationId", res.organizationId + "");
  localStorage.setItem("name", data.name);
}

export function actionUpdateInstitution(data) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      message.loading(getCurrentMessages().loading);

      let data_social = {
        socialInfo: {
          accountId: data.accountId,
          realName: data.realName,
          displayName: data.realName,
        },
      };
      await personaService.createOrUpdateSocial(data_social);

      let organizationId = +(localStorage.getItem("organizationId") || "");
      if (organizationId) {
        let dataArgs = {
          organizationId: organizationId,
          name: data.name,
        };
        await organizationService.updateOrganizationNameAndDescription(dataArgs);
      } else {
        createOrganization(data);
      }

      dispatch(actionUpdateInstitutionSuccess({}));
      dispatch(actionGetInstitution());
      message.destroy();
    } catch (error: any) {
      message.destroy();
      let response = error.response;
      if (response && response.status === 500) {
        let headers = error.response.headers;
        let str = headers["senno-exception-message"];
        if (str.toLowerCase().search("account id not found") != -1) {
          dispatch(
            actionLogoutSuccess({
              loginStatus: false,
              invaildLogin: true,
            })
          );
          console.log("重新登录...");
        } else {
          message.error("系统错误", 5);
          console.log("系统错误");
        }
      }
    }
  };
}

export const ACTION_UPDATEINSTITUTION_SUCCESS = "USER.ACTION_UPDATEINSTITUTION_SUCCESS";

export interface ActionUpdateInstitutionSuccessPayload {}

export const actionUpdateInstitutionSuccess = createAction(
  ACTION_UPDATEINSTITUTION_SUCCESS,
  (payload: ActionUpdateInstitutionSuccessPayload) => {
    return payload;
  }
);

//上传cos

export const cosConfig = {
  Bucket: "euler-1255704943", //replace with yours
  Region: "ap-guangzhou", //replace with yours
  SecretId: "AKIDhIjz615JfppdGioQDuRmwugGfx75sUwE", //replace with yours
  SecretKey: "c9XlqmWEpaEh2DD4oPuENMEwTt8GF3g9", //replace with yours
  cosDir: "dashboard/institutionLogo",
  cosUrl: "https://euler-1255704943.cos.ap-guangzhou.myqcloud.com/",
};

function returnCos() {
  let cos = new COS({
    getAuthorization: function (params, callback) {
      let authorization = COS.getAuthorization({
        SecretId: cosConfig.SecretId,
        SecretKey: cosConfig.SecretKey,
        Method: params.Method,
        Key: params.Key,
      });
      callback(authorization);
    },
  });
  return cos;
}

export function actionUpdateLogo(data) {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      let organizationId = +(localStorage.getItem("organizationId") || "");
      if (!organizationId) {
        message.warn("请先保存机构名称!");
        return;
      }
      message.loading(getCurrentMessages().loading);
      let cos = await returnCos();
      let times = new Date().getTime();
      let key = cosConfig.cosDir + "/" + times + ".jpg";
      let fileCosUrl = cosConfig.cosUrl + key;
      await cos.putObject(
        {
          Bucket: cosConfig.Bucket,
          Region: cosConfig.Region,
          Key: key,
          Body: data.file,
          onProgress: function (info) {
            let progress = JSON.stringify(info);
            console.log({ progress });
          },
        },
        async function (err, sdata) {
          console.log(err, sdata, fileCosUrl);
          if (err) {
            // message.error(err.error)
          } else {
            let dataArgs = {
              organizationId: organizationId,
              organizationLogo: fileCosUrl,
            };
            await organizationService.updateOrganizationNameAndDescription(dataArgs);
            dispatch(actionUpdateLogoSuccess({}));
            dispatch(actionGetInstitution());
          }
        }
      );
      message.destroy();
    } catch (error: any) {
      message.destroy();
      let response = error.response;
      if (response && response.status === 500) {
        let headers = error.response.headers;
        let str = headers["senno-exception-message"];
        if (str.toLowerCase().search("account id not found") != -1) {
          dispatch(
            actionLogoutSuccess({
              loginStatus: false,
              invaildLogin: true,
            })
          );
          console.log("重新登录...");
        } else {
          message.error("系统错误", 5);
          console.log("系统错误");
        }
      }
    }
  };
}

export const ACTION_UPDATELOGO_SUCCESS = "USER.ACTION_UPDATELOGO_SUCCESS";

export interface ActionUpdateLogoSuccessPayload {}

export const actionUpdateLogoSuccess = createAction(
  ACTION_UPDATELOGO_SUCCESS,
  (payload: ActionUpdateLogoSuccessPayload) => {
    return payload;
  }
);
